export default __webpack_public_path__ + "static/media/notfound.0a2258bc.png";